import(/* webpackMode: "eager" */ "/app/src/app/[locale]/our-plants/error.tsx");
